export default __webpack_public_path__ + "static/media/ProductDetails.de130235.svg";